import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AnimatedFish from '../game/AnimatedFish';
import AnimatedFriend from '../game/AnimatedFriend';

export default class AquariumItem extends Phaser.GameObjects.Container {
  static get ARRIVED_DESTINATION() {return 'arrived_at_destination';}

  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, itemName, itemID, x, y, partOffsets) {
    super(scene);

    this.itemName = itemName;
    this.itemID = itemID;
    this.curPos = { x,y };
    this.spritePartsOffsets = partOffsets;

    this.itemType = 'Fish';

    this.sprite = null;

    this.startPos = null;
    this.destPos = null;
    this.curScale = null;
    this.destScale = null;
    this.vX = null;
    this.vY = null;
    this.vScale = null;
    this.direction = 1;
    this.angle = null;
    this.speed = 42;
    this.minSpeed = 20;
    this.maxSpeed = 140;
    this.ease = 0.14;

    // Straight moves
    this.distanceToTarget = null;
    this.distanceTraveled = null;

    this.hoverPoint = null;
    this.hoverRange = null;
    this.borders = null;
    this.maxTop = null;
    this.maxLeft = null;
    this.maxBottom = null;
    this.maxRight = null;

    this.swimState = null;
    this.sinks = false; // Makes it go to bottom and stay on roam
    this.bottomBuffer = 52;

    this.rotates = false;
    this.rotateTween = null;

    this.bottomBuffer = Phaser.Math.Between(40,56);
    this.curScale = 1;
    this.destScale = 1;

    if (this.itemName === 'Fish') {
      this.sprite = new AnimatedFish(this.scene, this.itemName, this.itemID, this.spritePartsOffsets);
    }
    else if (this.itemName === 'Friend') {
      this.sprite = new AnimatedFriend(this.scene, this.itemName, this.itemID, this.spritePartsOffsets);
    }
    this.add(this.sprite);

    this.swimState = null;
    const bounds = this.getBounds();
    this.list.forEach((child) => {
      // eslint-disable-next-line no-param-reassign
      child.x -= bounds.width / 2;
      // eslint-disable-next-line no-param-reassign
      child.y -= bounds.height / 2;
    });
    this.initPositionValues(this.x, this.y, null);

    ABCyaPhaser.Container.setContainerInteractive(this);
    this.scene.input.setDraggable(this, true);
  }

  initPositionValues (curX, curY, borderValues) {
    this.curPos = { x: curX, y: curY };
    if (!borderValues) {
      this.borders = [0,0,this.scene.scale.width,this.scene.scale.height];
    }
    this.x = this.curPos.x;
    this.y = this.curPos.y;
  }

  getHitRect () {
    const w = this.getBounds().width;
    const h = this.getBounds().height;
    const rect = new Phaser.Geom.Rectangle(this.x - w / 2, this.y - h / 2, w, h);
    return rect;
  }

  turnDir (direction) {
    if (direction !== this.direction) {
      this.direction = direction;
      this.scene.tweens.killTweensOf(this);
      ABCyaPhaser.Tweens.addTween(this, 200, { scaleX: this.direction }, Phaser.Math.Easing.Linear);
    }
  }

  initializeInOut (destX, destY, destScale) {
    this.startPos = { x: this.x, y: this.y };
    this.curPos = { x: this.x, y: this.y };
    this.destPos = { x: destX, y: destY };

    this.ease = 0.14;
    this.vScale = 0.02;
    this.destScale = destScale;
    if (destScale < this.scaleX) {
      this.vScale *= -1;
    }
    else if (destScale < this.scaleX && this.direction > 0) {
      this.vScale *= -1;
    }
    else if (destScale > Math.abs(this.scaleX) && this.direction < 0) {
      this.vScale *= -1;
    }
    this.swimState = SWIM_IN_OUT;
  }

  initializeHover () {
    this.swimState = SWIM_HOVER;
    this.speed = 2;
    this.ease = 0.02;
    this.hoverRange = 13;
    this.maxLeft = this.x - this.hoverRange;
    this.maxTop = this.y - this.hoverRange * 2;
    this.maxRight = this.x + this.hoverRange;
    this.maxBottom = this.y + this.hoverRange * 2;

    this.startPos = { x: this.x, y: this.y };
    this.curPos = { x: this.x, y: this.y };
    this.destPos = { x: Phaser.Math.Between(this.maxLeft, this.maxRight), y: Phaser.Math.Between(this.maxTop, this.maxBottom) };
  }

  initializeRoam () {
    this.swimState = SWIM_ROAM;
    this.speed = Phaser.Math.Between(20,80);
    this.borders = [0,0,this.scene.scale.width,this.scene.scale.height];
    this.maxLeft = this.borders[0];
    this.maxTop = this.borders[1];
    this.maxRight = this.borders[2];
    this.maxBottom = this.borders[3];

    this.startPos = { x: this.x, y: this.y };
    this.curPos = { x: this.x, y: this.y };
    const destX = Phaser.Math.Between(this.maxLeft, this.maxRight);
    let destY = Phaser.Math.Between(this.maxTop, this.maxBottom);
    let dirMod = 1;
    if (this.startPos.x > destX) {
      dirMod = -1;
    }
    this.vX = this.speed * dirMod;
    if (this.startPos.y > destY) {
      dirMod = -1;
    }
    this.vY = this.speed * dirMod;
    if (this.sinks) {
      destY = this.maxBottom - this.bottomBuffer; // Things like the crap we want to keep on the bottom
      this.vY = Math.abs(this.speed * dirMod);
    }
    this.destPos = { x: destX, y: destY };

    if (this.itemName === 'Fish') {
      this.sprite.startSwimming();
    }
    else if (this.itemName === 'Friend') {
      this.sprite.startSwimming();
    }
    this.checkDirection();
  }

  checkDirection () {
    if (this.curPos.x > this.destPos.x) {
      this.direction = -1;
    }
    else {
      this.direction = 1;
    }
    this.scene.tweens.killTweensOf(this);
    if (this.scaleX !== this.direction) ABCyaPhaser.Tweens.addTween(this, 320, { scaleX: this.direction }, Phaser.Math.Easing.Quadratic.Out);
  }

  roamTank (delta) {
    if (this.vX >= 0) { // Moving right
      if (this.curPos.x > this.borders[2]) {
        this.checkDirection();
        this.speed = Phaser.Math.Between(this.minSpeed,this.maxSpeed);
        this.vX = -this.speed;

        this.borders[0] = Phaser.Math.Between(0,this.scene.scale.width / 6);

        this.doSpin(-1);
      }
    }
    else { // Moving left
      if (this.curPos.x < this.borders[0]) {
        this.checkDirection();
        this.speed = Phaser.Math.Between(this.minSpeed,this.maxSpeed);
        this.vX = this.speed;

        this.speed = Phaser.Math.Between(20,80);
        this.borders[2] = Phaser.Math.Between(this.scene.scale.width / 6, this.scene.scale.width);

        this.doSpin(1);
      }
    }

    if (this.vY <= 0) { // Moving up
      if (this.curPos.y < this.borders[1]) {
        this.checkDirection();
        this.doSpin();
        this.speed = Phaser.Math.Between(this.minSpeed,this.maxSpeed);
        this.vY = this.speed;
        this.borders[3] = Phaser.Math.Between(this.scene.scale.height / 6, this.scene.scale.height);
      }
    }
    else { // Moving down
      if (this.sinks) {
        if (this.curPos.y > this.maxBottom - this.bottomBuffer) {
          this.borders[1] = this.maxBottom - this.bottomBuffer;
          this.vY = 0;
        }
      }
      else if (this.curPos.y > this.borders[1]) {
        this.checkDirection();
        this.doSpin();
        this.speed = Phaser.Math.Between(this.minSpeed,this.maxSpeed);
        this.vY = -this.speed;
        this.borders[1] = Phaser.Math.Between(0, this.scene.scale.height);
      }
    }
    this.curPos.x += this.vX * delta;
    this.curPos.y += this.vY * delta;
  }

  doSpin (turnDir) {
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 200, { scaleX: turnDir ?? this.direction }, Phaser.Math.Easing.Linear);
    if (this.rotates) {
      this.angle = 0;
      let rmod = 1;
      Phaser.Math.Between(1,2) > 1 ? rmod = 1 : rmod = -1;
      ABCyaPhaser.Tweens.addTween(this, 600, { delay: 200, angle: 360 * rmod }, Phaser.Math.Easing.Linear);
    }
  }

  hoverSwim () {
    const dX = this.destPos.x - this.curPos.x;
    const dY = this.destPos.y - this.curPos.y;
    const distance = Phaser.Math.Distance.BetweenPoints(this.curPos, this.destPos);
    if (distance > 1) {
      this.curPos.x += dX * this.ease;
      this.curPos.y += dY * this.ease;
    }
    else {
      this.curPos.x = this.destPos.x;
      this.curPos.y = this.destPos.y;
      if (this.swimState === SWIM_HOVER) {
        this.pickNewHoverSpot();
      }
      else if (this.swimState === SWIM_TO_POINT) {
        this.swimState = null;
        this.emit(AquariumItem.ARRIVED_DESTINATION);
      }
    }
  }

  pickNewHoverSpot () {
    this.startPos = { x: this.x, y: this.y };
    this.curPos = { x: this.x, y: this.y };
    const destX = Phaser.Math.Between(this.maxLeft, this.maxRight);
    const destY = Phaser.Math.Between(this.maxTop, this.maxBottom);
    this.destPos = { x: destX, y: destY };

    this.ease = 0.006;
  }

  swimInOut () {
    const dX = this.destPos.x - this.curPos.x;
    const dY = this.destPos.y - this.curPos.y;
    const distance = Phaser.Math.Distance.BetweenPoints(this.curPos, this.destPos);
    if (distance > 1) {
      this.curPos.x += dX * this.ease;
      this.curPos.y += dY * this.ease;
      this.scaleX += this.vScale;
      this.scaleY += this.vScale * this.direction;
    }
    else {
      this.swimState = null;
      this.emit(AquariumItem.ARRIVED_DESTINATION);
    }
  }

  doAnimatedSwim () {
    this.sprite.startSwimming();
  }

  menuTick (delta) {
    this.sprite.tick(delta);
  }

  tick (delta) {
    // Swimming
    if (this.swimState) {
      switch (this.swimState) {
        case SWIM_ROAM:
          this.roamTank(delta);
          break;
        case SWIM_HOVER:
          this.hoverSwim();
          break;
        case SWIM_IN_OUT:
          this.swimInOut();
      }
    }
    this.x = this.curPos.x;
    this.y = this.curPos.y;
    this.sprite.tick(delta);
  }
}

const SWIM_TO_POINT = 1;
const SWIM_HOVER = 2;
const SWIM_STOP = 3;
const SWIM_ROAM = 4;
const SWIM_IN_OUT = 5;